import React, { useEffect } from "react";
import { useEquipmentV2Selector } from "../../../redux/store";
import { useEquipmentOptionalLabel } from "../../../utils/labels";
import Equipment from "../common/Equipment";
import useStatus from "../../../../../../common-deprecated/hooks/useStatus";
import useEquipmentColourPostal from "../../../hooks/useEquipmentColourPostal";
import { useModalMap } from "../../../../../../common-deprecated/containers/ModalProvider";
import { aemToyotaCommonModalMap } from "../../../../../../common-deprecated/components/modals/aem/modals";
import useInitEquipmentV2 from "../../../hooks/useInitEquipmentV2";
import { updateTrackingLayerVersioning } from "../../../utils/tracking";

const OptionalEquipment = (): JSX.Element | null => {
    const settings = useEquipmentV2Selector((state) => state.commonSettings);
    const equipment = useEquipmentV2Selector((state) => state.equipment);
    const optionalEquipmentLabels = useEquipmentOptionalLabel([
        "optionalEquipmentTitle",
        "optionalEquipmentDescription",
    ]);

    useEquipmentColourPostal();
    useInitEquipmentV2();
    useModalMap(aemToyotaCommonModalMap);
    useStatus(settings, "AEM Equipment");
    useEffect(() => {
        updateTrackingLayerVersioning();
    }, []);

    if (!equipment.loaded || equipment.error || !equipment.optional.length) return null;
    return <Equipment equipmentLabels={optionalEquipmentLabels} equipment={equipment.optional} />;
};

export default OptionalEquipment;
